//se cambio
import getImage from "../../../ClinicEvent/components/PdfReports/GetImage";
import pdfMake from "pdfmake/build/pdfmake.js";
import moment from "moment";
import "moment-timezone";
import { calculateAgeParse } from "../../../../Utils/Patient";

const NotesPDF = async (data) => {
  pdfMake.fonts = {
    OpenSans: {
      normal: "OpenSans-Regular.ttf",
      bold: "OpenSans-Bold.ttf",
      italics: "OpenSans-Italic.ttf",
      bolditalics: "OpenSans-ExtraBoldItalic.ttf",
    },
    Merriweather: {
      normal: "Merriweather-Regular.ttf",
      bold: "Merriweather-Bold.ttf",
      italics: "Merriweather-Italic.ttf",
      bolditalics: "Merriweather-ExtraBoldItalic.ttf",
    },
    Roboto: {
      normal: "Roboto-Regular.ttf",
      bold: "Roboto-Bold.ttf",
      italics: "Roboto-Italic.ttf",
      bolditalics: "Roboto-BoldItalic.ttf",
    },
  };

  const urlLogo = sessionStorage.getItem("logoURL");

  let services = [];

  services.push([
    { text: "Procedimientos", style: "tableheader", lineHeight: 1.2 },
  ]);
  for (let obj of data.servicios) {
    services.push([
      {
        text: obj.codigo + " - " + obj.nombre,
        style: "textStyle",
        margin: [0, -8, 0, 0],
      },
    ]);
  }

  const header = {
    margin: [40, 10, 0, 0],
    layout: "noBorders",
    table: {
      widths: ["*", "*"],
      body: [
        [
          {
            image: await getImage(urlLogo),
            fit: [100, 40],
          },
          {
            text:
              data.profile.direccion.direccion +
              " \n Teléfonos: " +
              data.profile.telefono1 +
              " \n" +
              data.profile.nombre,
            style: "head",
          },
        ],
      ],
    },
  };

  const foter = (currentPage, pageCount) => {
    return {
      table: {
        widths: ["*", "*", "*"],
        body: [
          [
            {
              text: "Página " + currentPage.toString() + " de " + pageCount,
              style: "foter",
            },
            { text: name, style: "foter" },
            {
              text:
                "Fecha Impresión: " +
                moment().tz("America/Bogota").format("DD/MM/YYYY"),
              style: "foter",
            },
          ],
        ],
      },
      layout: "noBorders",
      margin: [20, 0, 0, 5],
    };
  };

  const getTableNotes = async () => {
    let tableNotes = [];

    if (data.idNota == null) {
      tableNotes.push([{ text: "Notas Clínicas ", style: "tableheader" }]);
    } else {
      tableNotes.push([{ text: "Nota Clínica ", style: "tableheader" }]);
    }

    for (let i = 0; i < data.notes.length; i++) {
      let url_doctor_nota_evolucion =
        process.env.REACT_APP_PUBLIC_URL +
        data.notes[i].firma_doctor +
        "/" +
        sessionStorage.getItem("token");
      if (data.idNota != null) {
        if (data.idNota == data.notes[i].id_hist_nota_clin) {
          let item = [
            {
              text: organizeNote(data.notes[i]),
              bold: false,
              style: "textStyle",
            },
          ];
          let item2 = [
            { text: firma(data.notes[i]), bold: false, style: "textStyle" },
          ];
          let item3 = [
            {
              unbreakable: true,
              layout: "headerLineOnly",
              border: [false, false, false, false],
              table: {
                widths: [80],
                headerRows: 1,
                alignment: "left",
                body: [
                  [
                    {
                      image: await getImage(url_doctor_nota_evolucion),
                      fit: [80, 50],
                      alignment: "left",
                    },
                  ],
                ],
              },
            },
          ];
          tableNotes.push(item, item3, item2);
        }
      } else {
        let item = [
          {
            text: organizeNote(data.notes[i]),
            bold: false,
            style: "textStyle",
          },
        ];
        let item2 = [
          { text: firma(data.notes[i]), bold: false, style: "textStyle" },
        ];
        let item3 = [
          {
            unbreakable: true,
            layout: "headerLineOnly",
            border: [false, false, false, false],
            table: {
              widths: [80],
              headerRows: 1,
              alignment: "left",
              body: [
                [
                  {
                    image: await getImage(url_doctor_nota_evolucion),
                    fit: [80, 50],
                    alignment: "left",
                  },
                ],
              ],
            },
          },
        ];
        tableNotes.push(item, item3, item2);
      }
    }
    return tableNotes;
  };

  const organizeNote = (dataItem) => {
    let nota = `${dataItem.nota_clinica}\n`;
    return nota;
  };

  const firma = (dataItem) => {
    console.log("firma dataItem:", dataItem);
    let nota = `Autor: ${dataItem.nombre_usuario}\n`;
    nota += dataItem.especialidad
      ? `Especialidad: ${dataItem.especialidad}\n`
      : `Cargo: ${dataItem.nombre_cargo}\n`;
    nota =
      nota +
      `Fecha: ${moment(dataItem.fecha).format("DD-MM-YYYY h:mm:ss a")}\n\n`;
    return nota;
  };

  const documentDefinition = {
    pageSize: "LETTER",
    pageOrientation: "portrait",
    header: header,
    footer: foter,
    content: [
      {
        // auto-sized columns have their widths based on their content
        margin: [0, 20, 0, 10],
        layout: "headerLineOnly",
        table: {
          headerRows: 1,
          widths: ["auto", "*", "auto", "*"],
          body: [
            [
              { text: "Datos del Paciente ", style: "tableheader" },
              "",
              { text: "Admisión: " + data.admision, style: "tableheader" },
              {
                text:
                  "Fecha de Atención: " +
                  moment(data.patient.fecha_admision).format("DD-MM-YYYY"),
                style: "tableheader",
              },
            ],
            [
              { text: "Nombre ", bold: true, style: "textStyle" },
              { text: data.patient.names, style: "textStyle" },
              { text: "Identificación ", bold: true, style: "textStyle" },
              {
                text:
                  data.patient.typeOfDocument +
                  "-" +
                  data.patient.documentNumber,
                style: "textStyle",
              },
            ],
            [
              { text: "Fecha de Nacimiento ", bold: true, style: "textStyle" },
              { text: data.patient.birthday, style: "textStyle" },
              { text: "Edad ", bold: true, style: "textStyle" },
              {
                text: calculateAgeParse(data.patient.birthday),
                style: "textStyle",
              },
            ],
            [
              { text: "Dirección ", bold: true, style: "textStyle" },
              { text: data.patient.address, style: "textStyle" },
              { text: "Ciudad ", bold: true, style: "textStyle" },
              { text: data.patient.city, style: "textStyle" },
            ],
            [
              { text: "Genero ", bold: true, style: "textStyle" },
              { text: data.patient.gender, style: "textStyle" },
              { text: "Tel/Cel: ", bold: true, style: "textStyle" },
              { text: data.notes[0].telephone, style: "textStyle" },
            ],
          ],
        },
      },
      {
        // auto-sized columns have their widths based on their content
        margin: [0, 0, 0, 10],
        layout: "noBorders",
        table: {
          widths: ["*"],
          headerRows: 1,
          body: services,
        },
      },
      {
        margin: [0, 20, 0, 10],
        layout: "headerLineOnly",
        table: {
          headerRows: 1,
          widths: ["auto"],
          body: await getTableNotes(),
        },
      },
      {
        margin: [0, 10, 0, 0],
        text: "",
      },
    ],
    styles: {
      head: {
        fontSize: 7,
        bold: true,
        alignment: "left",
        font: "OpenSans",
      },
      tableheader: {
        fontSize: 9,
        bold: true,
        font: "OpenSans",
      },
      textStyle: {
        fontSize: 9,
        font: "OpenSans",
      },
      paragraf: {
        fontSize: 10,
        alignment: "justify",
        font: "OpenSans",
      },
      foter: {
        margin: 10,
        fontSize: 6,
        font: "OpenSans",
      },
      medicStyle: {
        margin: [0, 80, 0, 0],
        fontSize: 10,
        alignment: "left",
        font: "OpenSans",
      },
    },
  };

  //pdfMake.createPdf(documentDefinition).open();
  const pdfDocGenerator = pdfMake.createPdf(documentDefinition);
  pdfDocGenerator.getDataUrl(function (outDoc) {
    document.getElementById("pdfV").src = outDoc;
  });
};

export default NotesPDF;
